<template>
  <div class="jd-box">
      <vueSearch @click="$router.push('/taobao/search')"></vueSearch>
     <van-tabs v-model="active" @change="changeTab">
     <van-tab v-for="(item,index) in catList" :title="item.name" :key="index">
      </van-tab>
     </van-tabs>
      <recommendList></recommendList>
      <good v-for="(item,index) in goodList"
       :good="item"
      :key="index">
    </good>
      <van-button type="default" size="large" v-show="more" @click="loadMore">加载更多</van-button>
  </div>
</template>

<script>
  import good from '@/components/jd/good'
export default {
  components:{
    good
  },
  data() {
    return {
      keyword: "", //搜索词
      active:0,
       page: 1,
      more: true, // 是否有分页
      goodList: [],
       catList:[
        {name:'为你推荐',value:'23'},
        {name:'数码家电',value:'24'},
        {name:'超市',value:'25'},
        {name:'母婴玩具',value:'26'},
        {name:'家具日用',value:'27'},
        {name:'美妆穿搭',value:'28'},
        {name:'医药保健',value:'29'},
        {name:'图书文具',value:'30'},
      ], //分类列表
    //  1-好券商品,2-超级大卖场,10-9.9专区,22-热销爆品,23-为你推荐,24-数码家电,25-超市,26-母婴玩具,27-家具日用,28-美妆穿搭,29-医药保健,30-图书文具,
    //  31-今日必推,32-品牌好货,33-秒杀商品,34-拼购商品,40-高收益,41-自营热卖榜,109-新品首发,110-自营,125-首购商品,129-高佣榜单,130-视频商品
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData(){
      const eliteId = this.catList[this.active].value
      this.Post(
        {
          eliteId,
          page:this.page,
        },
        "/jd/goodsJingfenQuery",
        res => {
          if (res.states == 1) {
            const data = JSON.parse(res.data.jd_union_open_goods_jingfen_query_response.result)
            if(data.code === 200){
              const list = data.data || [];
              if(list.length === 0){
                this.more = false
              }
              console.log(list[0])
              this.goodList = [...this.goodList, ...list];
            }else {
              this.more = false
            }
          }
        }
      );
    },
     // 加载更多
    loadMore() {
      if (this.more) {
        this.page++;
        this.getData();
      }
    },
    changeTab(){
      this.page =1;
      this.goodList = [];
      this.more = true;
      this.getData();
    },
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.jd-box {
}
</style>



// WEBPACK FOOTER //
// src/pages/jd/index.vue